import { useIdleTimer } from "react-idle-timer";
import { useAuth } from "@/hooks";
import { useGetSettingsQuery } from "@/app/settingsApi";

const SECOND = 1000;
const MINUTE = 60;
const DEFAULT_TIMEOUT = 30;

export function IdleTimerProvider({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();
  const { data: settings } = useGetSettingsQuery();

  const onIdle = () => logout();

  useIdleTimer({
    timeout:
      (settings?.idleTimeoutInMinutes ?? DEFAULT_TIMEOUT) * SECOND * MINUTE,
    onIdle,
  });

  return children;
}
